// extracted by mini-css-extract-plugin
export var body = "eoex8LQdkPdxedsUDriM";
export var hero = "tBr1eaYunKD1v5RO0cdU";
export var large = "Kx3SCjAWkS77HSTEdXhz";
export var micro = "TIB1_UJ4URdhZK5rn75C";
export var mini = "njP7drpHgt0WR0mW8iem";
export var small = "jKMe7S3hrXm0Xq9FG0K5";
export var title1 = "INYDOM3Ivz4SgfbkCrgu";
export var title2 = "vquzDda_W5tapKzc35vL";
export var title3 = "tEwMeqkM3UEp6P00M6tQ";